/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Ask_Questions_Label_NoInputs */

const es_components_ask_questions_label_no = /** @type {(inputs: Components_Ask_Questions_Label_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const en_components_ask_questions_label_no = /** @type {(inputs: Components_Ask_Questions_Label_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

/**
* | output |
* | --- |
* | "No" |
*
* @param {Components_Ask_Questions_Label_NoInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_ask_questions_label_no = /** @type {((inputs?: Components_Ask_Questions_Label_NoInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Ask_Questions_Label_NoInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_ask_questions_label_no(inputs)
	return en_components_ask_questions_label_no(inputs)
});
export { components_ask_questions_label_no as "components.ask_questions.label.no" }